//租聘权招商

export default {
  state: {
    form: {
      areaArray: [],
      leaseType: '',
      areaType: '',
      name: '',
      leaseArea: '',
      houseStructure: '',
      costBearer: '',
      leaseRoomNumber: '',
      images: [],
      lessorName: '上海闵行国资委',
      lessorAddress: '上海市闵行区都市路888弄',
      deedFlag: '',
      leaseAddress: '',
      currentDesc: '',
      lessorContact: '',
      lessorContactNumber: '',
      brightSpot: '',
      powerSituation: "",
      legalPurposes: "",
      actualUse: "",
      bidderQualification: '',
      preAuditMethod: '',
      originalTenantName: '',
      originalTenantNumber: '',
      priorityQualification: '',
      managementCapacity: '',
      registeredAddress: '',
      businessNow: '',
      remark: '',
      leaseDeadline: '',
      viewTime: [],
      annualIncrementRate: '',
      operatingType: '',
      freePeriod: '1',
      businessAgreement: '',
      rentAgreement: '',
      houseStructureAgreement: '',
      maintainAgreement: '',
      safetyAgreement: '',
      lesseeOtherAgreement: '',
      levyAgreement: '',
      renewalAgreement: '',
      terminationContractAgreement: '',
      disputeResolutionAgreement: '',
      defaultLiabilityAgreement: '',
      contractOtherAgreement: '',
      paymentCycle: '',
      commission: '',
      enrollingPrice: '',
      serverAgencyId: "10086",
      lessorCommissionRate: "",
      lesseeCommissionRate: "",
      deposit: "",
      reservePrice: "",
      previewAt: "",
      previewAtDesc: "",
      applyEndTime: "",
      applyEndTimeDesc: "",
      approvalEndTime: "",
      approvalEndTimeDesc: "",
      beginAt: '',
      beginAtDesc: '',
      endAt: '',
      endAtDesc: '',
      payDays: '',
      handoverDays: '',
      recruitmentDocument: [],
      bidderInformation: [],
      other: [],
      jointStatus: '',
      expectedMode: 'ENGLISH',
      startingPrice: '',
      increment: '',
      reduction: '',
      reductionPeriod: '',
      extra:{
        images:[],
      },
    },
  },
  mutations: {
    SET_MERCHANT_FORM(state, form) {
      let stateFrom = state.form
      let newFrom = Object.assign(stateFrom, form)
      newFrom.viewTime = [newFrom.viewBeginTime||'', newFrom.viewEndTime||'']
      newFrom.time = [newFrom.beginAt||'', newFrom.endAt||'']
      let areaArray = newFrom.areaArray
      let arr = []
      if (areaArray&&areaArray.length) {
        for (let i = 0; i < areaArray.length; i++) {
          arr.push(
            [areaArray[i].provinceId || '', areaArray[i].id || '', areaArray[i].areaId || '']
          )
        }
      } else {
        arr = []
      }
      newFrom.areaArray = arr
      // newFrom.images=(newFrom.extra&&newFrom.extra.images)||[]
      state.form = newFrom
    },
    RESET_MERCHANT(state) {
      state.form = {
        areaArray: [],
        leaseType: '',
        areaType: '',
        name: '',
        leaseArea: '',
        houseStructure: '',
        costBearer: '',
        leaseRoomNumber: '',
        images: [],
        lessorName: '上海闵行国资委',
        lessorAddress: '上海市闵行区都市路888弄',
        deedFlag: '',
        leaseAddress: '',
        currentDesc: '',
        lessorContact: '',
        lessorContactNumber: '',
        brightSpot: '',
        powerSituation: "",
        legalPurposes: "",
        actualUse: "",
        bidderQualification: '',
        preAuditMethod: '',
        originalTenantName: '',
        originalTenantNumber: '',
        priorityQualification: '',
        managementCapacity: '',
        registeredAddress: '',
        businessNow: '',
        remark: '',
        leaseDeadline: '',
        viewTime: [],
        annualIncrementRate: '',
        operatingType: '',
        freePeriod: '1',
        businessAgreement: '',
        rentAgreement: '',
        houseStructureAgreement: '',
        maintainAgreement: '',
        safetyAgreement: '',
        lesseeOtherAgreement: '',
        levyAgreement: '',
        renewalAgreement: '',
        terminationContractAgreement: '',
        disputeResolutionAgreement: '',
        defaultLiabilityAgreement: '',
        contractOtherAgreement: '',
        paymentCycle: '',
        commission: '',
        enrollingPrice: '',
        serverAgencyId: "10086",
        lessorCommissionRate: "",
        lesseeCommissionRate: "",
        deposit: "",
        reservePrice: "",
        previewAt: "",
        previewAtDesc: "",
        applyEndTime: "",
        applyEndTimeDesc: "",
        approvalEndTime: "",
        approvalEndTimeDesc: "",
        beginAt: '',
        beginAtDesc: '',
        endAt: '',
        endAtDesc: '',
        payDays: '',
        handoverDays: '',
        recruitmentDocument: [],
        bidderInformation: [],
        other: [],
        time: [],
        jointStatus: '',
        expectedMode: 'ENGLISH',
        startingPrice: '',
        increment: '',
        reduction: '',
        reductionPeriod: '',
        extra:{
          images:[],
        },
      }
    },
  },
  actions: {
    setMerchantForm({commit}, form) {
      commit('SET_MERCHANT_FORM', form)
    },
    resetMerchant({commit}) {
      commit('RESET_MERCHANT')
    },
  },
}
